module.exports = __webpack_public_path__ + "static/media/globus.036ad0f8.svg";